// iOS Safari zooms in on any text field under 16px when it is focused, and leaves the
// page zoomed. maximum-scale=1 stops that zoom while iOS still lets the user pinch, so
// fields keep their designed size. iOS only: Android honours it and would lose pinch-zoom.
export const stopIosFocusZoom = (): void => {
  if (!CSS.supports("-webkit-touch-callout", "none")) return;
  const viewport = document.querySelector('meta[name="viewport"]');
  viewport?.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1");
};
